import React, { useCallback, useEffect, useState } from 'react'
import { useParams } from 'react-router-dom'
import ResultsDialog from './Dialog'
import { Alert, Box, Typography } from '@mui/material'
import List from './List'
import { useSelector } from 'react-redux'
import ButtonStartIcon from '../../../../../../button/ButtonStartIcon'
import { handlerErrorV2 } from '../../../../../../../utils/errors'
import InputField from '../../../../../../FormControl/input/InputField'
import { getAllModules } from '../../../../../../../services/analytics/analytics-curriculum.service'

const Results = () => {
  const [modal, setModal] = useState(null)
  const [update, setUpdate] = useState(false)
  const [list, setList] = useState([])
  const [listTemp, setListTemp] = useState([])
  const [isLoadingList, setIsLoadingList] = useState(false)
  const [filter, setFilter] = useState({})
  const [error, setError] = useState(null)
  const roles = useSelector((state) => state?.session.user.roles?.map((r) => r.id))
  const { code } = useParams()

  const onLoad = useCallback(async () => {
    setIsLoadingList(true)
    setError(null)
    try {
      const response = await getAllModules(code, 'results')
      if (!response?.data && response?.error) {
        setError(response.error.message || 'An error ocurred')
      } else {
        setList(response?.data || [])
        setListTemp(response?.data || [])
      }
    } catch (error) {
      const message = handlerErrorV2(error)
      setError(message)
    } finally {
      setIsLoadingList(false)
    }
  }, [])

  const onSearch = (key, value) => {
    setFilter({ ...filter, [key]: value })
    if (value.length === 0) {
      setList(listTemp)
    } else {
      const filterData = listTemp.filter(
        (item) =>
          item.name.toLowerCase().includes(value.toLowerCase()) ||
          item.code.toLowerCase().includes(value.toLowerCase())
      )
      setList(filterData)
    }
  }

  useEffect(() => {
    onLoad()
  }, [onLoad, update])

  return (
    <>
      <Box className='bg-primary text-primary-foreground px-4 py-1 flex gap-4 items-center justify-between sticky top-0 z-10 h-8'>
        <Typography variant='subtitle1' className='uppercase'>
          Results
        </Typography>
        {!isLoadingList && !roles.some((r) => ['Student', 'Parent'].includes(r)) && (
          <ButtonStartIcon
            onClick={() =>
              setModal({
                type: 'create',
                form: {
                  position:
                    list.sort((a, b) => a.position - b.position)[
                      list.sort((a, b) => a.position - b.position).length - 1
                    ]?.position + 1 || 1,
                  priority:
                    list.sort((a, b) => a.priority - b.priority)[
                      list.sort((a, b) => a.priority - b.priority).length - 1
                    ]?.priority + 1 || 1,
                  code: '',
                  name: '',
                  description: ''
                }
              })
            }
            color='secondary'
            variant='contained'
            startIcon={['fas', 'plus']}
          >
            Create
          </ButtonStartIcon>
        )}
      </Box>
      <div className='flex gap-2 items-center justify-between items-center py-2'>
        <div className='flex gap-2 justify-start'>
          <ButtonStartIcon
            variant='text'
            startIcon='bars-filter'
            title='Filter'
            color='primary'
            classNameIcon='text-3xl'
            size='large'
          >
            Filter
          </ButtonStartIcon>
          <div className='max-w-250px'>
            <InputField placeholder='Search' onChange={(e) => onSearch('search', e.target.value)} />
          </div>
        </div>
      </div>
      <Box className='px-2 py-2 absolute top-24 bottom-0 inset-x-0'>
        {error ? (
          <Alert severity='error'>{error}</Alert>
        ) : (
          <List
            isLoading={isLoadingList}
            permissions={{
              preview: !roles.some((r) => ['Student', 'Parent'].includes(r)),
              update: !roles.some((r) => ['Student', 'Parent'].includes(r)),
              delete: !roles.some((r) => ['Student', 'Parent'].includes(r))
            }}
            list={list?.sort((a, b) => a.code - b.code) || []}
            onAction={(type, form) => setModal({ type, form })}
          />
        )}
      </Box>
      {modal && (
        <ResultsDialog
          type={modal.type}
          show={!!modal}
          onClose={() => setModal(null)}
          formData={modal.form}
          onReset={() => setUpdate(!update)}
        />
      )}
    </>
  )
}

export default Results
